module.exports = "/build/web/svg/star.99e7da82ea17076b171ad62cf92c92dd.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/star.svg
// module id = 95
// module chunks = 24